import { useEffect } from "react";
import config from "~/config";
import useCurrentUser from "./useCurrentUser";

// The whole app reads time formatting from the local `config` store, but that store is only ever
// written when the user changes a dropdown on the profile page. Seed it from the user's saved
// profile (`behaviour`) on load so every config-based time display reflects the DB preference on a
// fresh login/machine, not just after re-toggling the dropdown.
const useSyncTimePreferences = () => {
  const { query } = useCurrentUser();
  const behaviour = query.data?.person?.behaviour;
  const timeLocale = behaviour?.timeLocale;
  const timezoneSelect = behaviour?.timezoneSelect;

  useEffect(() => {
    if (timeLocale) config.set("timezone.timeLocale", timeLocale);
    if (timezoneSelect) config.set("timezone.preference", timezoneSelect);
  }, [timeLocale, timezoneSelect]);
};

export default useSyncTimePreferences;
